import { Auth } from "../authentication.js";
import { performSyscall } from "./syscall.js";

export function setupAuth(): Auth {
  return {
    getUserIdentity: () => {
      const syscallJSON = performSyscall("getUserIdentity", {});
      return Promise.resolve(syscallJSON);
    },
  };
}
